__turbopack_context__.v({
  "root": "CarouselSection-module-scss-module__HUR5eW__root",
});
